import { render } from "./ResellerFeatures.vue?vue&type=template&id=564c1304&scoped=true"
import script from "./ResellerFeatures.vue?vue&type=script&lang=js"
export * from "./ResellerFeatures.vue?vue&type=script&lang=js"

import "./ResellerFeatures.vue?vue&type=style&index=0&id=564c1304&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-564c1304"]])

export default __exports__